<template lang="pug">
v-text-field(
    v-bind="$attrs"
    v-on="$listeners"
    :rules="databaseRules"
    label='Database'
    data-track="database"
    dense clearable outlined required)

</template>

<script lang="ts">
import isConvertibleToNotBlankString from '@/utils/isConvertibleToNotBlankString';
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class InputDatabase extends Vue {
  databaseRules = [(v: string) => isConvertibleToNotBlankString(v) || 'Database is required'];
}
</script>
